<template>
  <kst-page-new
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details
      :userData="userData"
      :categoryOptions="categoryOptions"
    />
  </kst-page-new>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../ExpcModel.js";
import Services from "../../../services/Api/ExpenseCategoryServices.js";

import Details from "./ExpcN_Details.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    Details
  },
  data: () => ({
    userData: {},
    categoryOptions: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(loadNew) {
      this.resetData();

      const config = Services.getNewData();
      loadNew(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.categoryOptions = Model.createCategoryOptions(data.CategoryList);
      Model.New.setDetailsByCategoryOptions(
        this.userData, this.categoryOptions
      );
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData);
      const config = Services.postData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
      this.categoryOptions = {};
    }
  }
}
</script>